<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Mary Washington House</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Rising Sun Tavern</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Hugh Mercer Apothecary Shop</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. St. George’s Episcopal Church</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Chimneys</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Kenmore</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Hazel Hill</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Fredericksburg Battlefield</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Mannsfield</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Chatham Manor</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Aquia Episcopal Church</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Spotsylvania Confederate Cemetery</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Barnes &amp; Noble</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. UFO Sightings</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Bigfoot Sighting</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?516b3fca